import styled from 'styled-components';
import {BLACK, GREY_2} from "../../../utils/colors";
import device from "../../../utils/mediaQuery";

export const Container = styled.section`
  background: #fff;
  padding: 20px;
`;

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 40px 20px 16px 20px;
  background: #fff;
  
    @media ${device.large} {
      padding: 0;
      background: unset;
    }
`;

export const BackIconWrapper = styled.div`
  position: absolute;
  left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10;
  pointer-events: auto;
  user-select: none;
  
  svg {
    pointer-events: none;
    path {
      fill: ${BLACK} !important;
    }
  }
  
  @media ${device.large} {
    left: 0;
  }
`;

export const HeaderNameContainer = styled.div`
  border-radius: 100px;
  background: ${GREY_2}
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const TimelineContainer = styled.div`
  flex: 1;
  text-align: center;
`;

export const TimelineWrapper = styled.div`
    display: inline-flex;
    width: 700px;
    padding: 0;
`;
